import React from "react";
import "../components/ReportModall.css";
import "../articlesblogs/FilterBlog.css";
// Import SVG

const LogoutModal = ({ open, onClose, onConfirm, isLoading = false }) => {
  if (!open) return null;

  const closeAll = () => {
    onClose();
  };

  return (
    <div className="modal-overlay resetModal unlockModal delModal" onClick={onClose}>
      <div
        className="modal-container text-center rounded-4"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
           <div className="close-btn2 text-end unlock-close-btn">
              <button
                type="button"
                className="btn-close"
                onClick={closeAll}
                aria-label="Close"
              > </button>
            </div>
        {/* Icon */}
        <div className="premium-icon delete-trash">
          <i className="bi bi-exclamation-circle-fill"></i>
        </div>

        {/* Title */}
        <h5 className="fw-bold blackText mb-2">
           Alert !
        </h5>

        {/* Description */}
        <p className="grayText fw-semibold">
         Are you Sure You want to Logout ?
        </p>

        <div className="filter-blog-modal__footer">
          <button type="button" className="filter-blog-modal__action delete-close" onClick={closeAll}>
            <span>Cancel</span>
          </button>
          <button
            type="button"
            className="filter-blog-modal__action filter-blog-modal__action--apply blockDoubt-btn"
            disabled={isLoading}
            onClick={onConfirm}
          >
            <span>{isLoading ? "Logging Out..." : "Logout"}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
